import type { components } from './generated-api.js';

type Schemas = components['schemas'];

export type TrialAppointmentDetail = Schemas['TrialAppointmentDetailDto'];
export type TrialAppointmentListItem = Schemas['TrialAppointmentListItemDto'];
export type TrialAppointmentsPage = Schemas['TrialAppointmentsPageDto'];
export type TrialAppointmentsQuery = Schemas['TrialAppointmentsQueryDto'];
export type TrialPerson = Schemas['TrialPersonDto'];
export type FormalLink = Schemas['FormalLinkDto'];
export type TrialEnrollment = Schemas['TrialEnrollmentRequestDto'];
export type TrialEnrollmentResult = Schemas['TrialEnrollmentResponseDto'];
export type TrialLinkCorrection = Schemas['TrialLinkCorrectionDto'];
export type GrowthQuery = Schemas['GrowthQueryDto'];
export type GrowthPage = Schemas['GrowthPageDto'];
export type AssessmentStandard = Schemas['AssessmentStandardDto'];
export type CategoryRating = Schemas['CategoryRatingDto'];
export type TeachingDetail = Schemas['TeachingDetailDto'];
export type TeachingHistory = Schemas['TeachingHistoryDto'];
export type TeachingCorrection = Schemas['TeachingCorrectionDto'];
export type TeachingPublicInput = Schemas['TeachingPublicInputDto'];
export type TrialAssessment = Schemas['TrialAssessmentCommandDto'];
export type TrialFeedback = Schemas['TrialFeedbackCommandDto'];
export type TeachingWriteResult = Schemas['TeachingWriteResponseDto'];
export type ReportManifest = Schemas['ReportManifestDto'];
export type ReportSnapshot = NonNullable<ReportManifest['publicSnapshot']>;
export type ReportDownloadAuthorization = Schemas['ReportDownloadAuthorizationDto'];
export type TrialSourcesPage = Schemas['LinkedTrialSourcesPageDto'];
export type PurchaseInput = Schemas['CreatePurchaseRequestDto'];
export type TrialPersonSummary = Schemas['TrialPersonSummaryDto'];
export type TrialPeoplePage = Schemas['TrialPeoplePageDto'];
export type TrialPeopleQuery = Schemas['TrialPeopleQueryDto'];
export type TrialOptionsPage = Schemas['TrialOptionsPageDto'];
export type TrialOptionsQuery = Schemas['TrialOptionsQueryDto'];
export type TrialCreate = Schemas['TrialCreateDto'];
export type TrialUpdate = Schemas['TrialUpdateDto'];
export type TrialTeaching = Schemas['TrialTeachingDto'];
export type TrialFollowUp = Schemas['TrialFollowUpDto'];
export type TrialFollowUpsPage = Schemas['TrialFollowUpsPageDto'];
export type TrialHandover = Schemas['TrialHandoverDto'];
export type TrialCorrection = Schemas['TrialCorrectionDto'];
export type TrialCorrectionsPage = Schemas['TrialCorrectionsPageDto'];
export type TrialHistoryPageResponse = Schemas['TrialHistoryPageResponseDto'];
export type TrialTasksPage = Schemas['TrialTasksPageDto'];
export type TrialTasksQuery = Schemas['TrialTasksQueryDto'];
export type TrialTask = Schemas['TrialTaskDto'];
export type TrialFollowUpResponse = Schemas['TrialFollowUpResponseDto'];

export type Employee = Schemas['EmployeeResponseDto'];
export type EmployeeAudit = Schemas['EmployeeAuditResponseDto'];
export type EmployeeList = Schemas['EmployeeListResponseDto'];
export type SessionUser = Schemas['SessionResponseDto'];
export type FileStatus = Schemas['FileStatusResponseDto'];
export type Student = Schemas['StudentResponseDto'];
export type StudentAudit = Schemas['StudentAuditResponseDto'];
export type StudentList = Schemas['StudentListResponseDto'];
export type StudentOperations = Schemas['StudentOperationsDto'];
export type StudentFollowUps = Schemas['FollowUpsEnvelopeDto'];
export type StudentFollowUp = Schemas['FollowUpRecordDto'];
export type StudentFollowUpCorrections = Schemas['CorrectionsEnvelopeDto'];
export type CreateStudentFollowUpInput = Schemas['CreateFollowUpDto'];
export type CorrectStudentFollowUpInput = Schemas['CorrectFollowUpDto'];
export type StudentFollowUpWriteResult = Schemas['FollowUpWriteResultDto'];
export type StudentFollowUpCorrectionResult = Schemas['FollowUpCorrectionResultDto'];
export type SetStudentResponsibleCoachInput = Schemas['SetStudentResponsibilityDto'];
export type StudentResponsibleCoachResult = Schemas['StudentResponsibilityResultDto'];
export type StudentRemindersInput = Schemas['StudentRemindersQueryDto'];
export type StudentReminders = Schemas['ReminderEnvelopeDto'];
export type CurrentRenewalFact = Schemas['CurrentRenewalFactDto'];
export type CurrentRenewalSummary = Schemas['CurrentRenewalSummaryDto'];
export type CurrentRenewalDetails = Schemas['CurrentRenewalDetailsDataDto'];
export type CurrentRenewalPurchase = Schemas['CurrentRenewalPurchaseDto'];
export type UploadPurpose = Schemas['CreateUploadRequestDto']['purpose'];
export type PackageTemplate = Schemas['PackageTemplateResponseDto'];
export type CommissionFormula = Schemas['FormulaResponseDto'];
export type CommissionPlan = Schemas['CommissionPlanResponseDto'];
export type CommissionPlanList = Schemas['CommissionPlanListResponseDto'];
export type CommissionPlanRevisionList = Schemas['CommissionPlanRevisionListResponseDto'];
export type Purchase = Schemas['PurchaseResponseDto'];
export type StudentPurchase = Schemas['StudentPurchaseProjectionDto'];
export type StudentConsumption = Schemas['StudentConsumptionProjectionDto'];
export type StudentConsumptionList = Schemas['StudentConsumptionListResponseDto'];
export type ConsumptionCreateInput = Schemas['CreateConsumptionBatchRequestDto'];
export type ConsumptionThemeCorrection = Schemas['CorrectConsumptionThemeDto'];
export type Consumption = Schemas['ConsumptionResponseDto'];
export type ConsumptionBatch = Schemas['ConsumptionBatchResponseDto'];
export type ConsumptionBatchAuditList = Schemas['ConsumptionBatchAuditListResponseDto'];
export type ConsumptionBatchPreview = Schemas['ConsumptionBatchPreviewResponseDto'];
export type ConsumptionList = Schemas['ConsumptionListResponseDto'];
export type ConsumptionOptions = Schemas['ConsumptionOptionsResponseDto'];
export type ConsumptionPreviewLine = Schemas['ConsumptionPreviewLineDto'];
export type CommissionSummary = Schemas['CommissionSummaryResponseDto'];
export type CommissionDetails = Schemas['CommissionDetailsResponseDto'];
export type SalesCommissionMonths = Schemas['SalesCommissionMonthsResponseDto'];
export type MySalesCommissionMonths = Schemas['MySalesCommissionMonthsResponseDto'];
export type SalesCommissionPurchases = Schemas['SalesCommissionPurchasesResponseDto'];
export type SalesCommissionPlan = Schemas['SalesCommissionPlanResponseDto'];
export type SalesCommissionPlanList = Schemas['SalesCommissionPlanListResponseDto'];
export type SalesCommissionPlanRevisionList = Schemas['SalesCommissionPlanRevisionListResponseDto'];
export type CreateExportTask = Schemas['CreateExportTaskRequestDto'];
export type ExportTask = Schemas['ExportTaskResponseDto'];
export type ExportTaskList = Schemas['ExportTaskListResponseDto'];
export type NotificationList = Schemas['NotificationListResponseDto'];
export type AuditList = Schemas['AuditListResponseDto'];
export type ReconciliationRun = Schemas['ReconciliationRunResponseDto'];
export type ReconciliationRunList = Schemas['ReconciliationRunListResponseDto'];
export type ConsumptionAnalyticsOverview = Schemas['ConsumptionAnalyticsOverviewResponseDto'];
export type TeacherRanking = Schemas['TeacherRankingResponseDto'];
export type StudentRanking = Schemas['StudentRankingResponseDto'];
export type AnalyticsFilterOptions = Schemas['AnalyticsFilterOptionsResponseDto'];
export type TrialConversionAnalyticsInput = Schemas['TrialConversionQueryDto'];
export type TrialConversionAnalytics = Schemas['TrialConversionQueryResponseDto'];
export type TrialConversionDetailsInput = Schemas['TrialConversionDetailsQueryDto'];
export type TrialConversionDetails = Schemas['TrialConversionDetailsQueryResponseDto'];
export type TrialConversionSeed = Schemas['TrialConversionDetailSeedDto'];
export type TrialConversionPerson = Schemas['TrialConversionPersonDto'];
export type VenueAnalyticsInput = Schemas['VenueAnalyticsQueryDto'];
export type VenueAnalytics = Schemas['VenueAnalyticsQueryResponseDto'];
export type VenueDetailsInput = Schemas['VenueDetailsQueryDto'];
export type VenueDetails = Schemas['VenueDetailsQueryResponseDto'];
export type AnalyticsDirectoryInput = Schemas['AnalyticsFilterOptionsPostQueryDto'];
export type AnalyticsDirectory = Schemas['AnalyticsFilterOptionsPostResponseDto'];
export type FrontDeskAnalyticsInput = Schemas['FrontDeskAnalyticsQueryDto'];
export type FrontDeskAnalytics = Schemas['FrontDeskAnalyticsResponseDto'];
export type FrontDeskDetailsInput = Schemas['FrontDeskDetailsQueryDto'];
export type FrontDeskDetails = Schemas['FrontDeskDetailsResponseDto'];
export type StudentsAnalyticsInput = Schemas['StudentsAnalyticsQueryDto'];
export type StudentsAnalytics = Schemas['StudentsAnalyticsResponseDto'];
export type StudentsDetailsInput = Schemas['StudentsDetailsQueryDto'];
export type StudentsDetails = Schemas['StudentsDetailsResponseDto'];
export type CoachesAnalyticsInput = Schemas['CoachesAnalyticsQueryDto'];
export type CoachesAnalytics = Schemas['CoachesAnalyticsResponseDto'];
export type CoachesDetailsInput = Schemas['CoachesDetailsQueryDto'];
export type CoachesDetails = Schemas['CoachesDetailsResponseDto'];
export type AnalyticsMetric = Schemas['AnalyticsMetricDto'];
export type DailyTaskTemplate = Schemas['DailyTaskTemplateDto'];
export type DailyTaskTemplateList = Schemas['DailyTaskTemplateListResponseDto'];
export type DailyTaskTemplateRevisionList = Schemas['DailyTaskTemplateRevisionListResponseDto'];
export type DailyTaskToday = Schemas['DailyTaskTodayDto'];
export type DailyTaskSummary = Schemas['DailyTaskSummaryDto'];
export type DailyTaskReviewList = Schemas['DailyTaskReviewListResponseDto'];
export type DailyTaskReviewQueueItem = Schemas['DailyTaskReviewQueueItemDto'];
export type DailyTaskInstance = Schemas['DailyTaskInstanceDetailDto'];
export type DailyTaskSubmission = Schemas['DailyTaskSubmissionDto'];
export type DailyTaskEvidenceList = Schemas['DailyTaskEvidenceListResponseDto'];
export type DailyTaskEvidenceItem = Schemas['DailyTaskEvidenceItemDto'];

interface ApiErrorBody {
  readonly details?: unknown;
  readonly code?: string;
  readonly fieldErrors?: readonly { readonly field: string; readonly message: string }[];
  readonly message?: string;
  readonly requestId?: string;
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly fieldErrors: readonly { readonly field: string; readonly message: string }[] = [],
    readonly details: Readonly<{ currentVersion?: string; currentPersonVersion?: string }> = {},
    readonly requestId?: string,
  ) {
    super(message);
  }
}

export type PurchaseActivity = Schemas['PurchaseActivityResponseDto'];
export type PurchaseActivityItem = Schemas['PurchaseActivityItemDto'];

let csrfToken: string | undefined;

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  const method = init.method?.toUpperCase();
  if (init.body !== undefined || (method !== undefined && method !== 'GET' && method !== 'HEAD')) {
    headers.set('content-type', 'application/json');
  }
  if (csrfToken !== undefined && init.method !== undefined && init.method !== 'GET') {
    headers.set('x-csrf-token', csrfToken);
  }
  const response = await fetch(`/api/v1${path}`, {
    ...init,
    credentials: 'include',
    headers,
  });
  const body: unknown = await response.json().catch(() => undefined);
  if (!response.ok) {
    const errorBody = isApiErrorBody(body) ? body : {};
    const error = new ApiError(
      response.status,
      errorBody.code ?? 'UNKNOWN_ERROR',
      errorBody.message ?? '请求失败，请稍后重试',
      errorBody.fieldErrors ?? [],
      safeVersionDetails(errorBody.details),
      typeof errorBody.requestId === 'string' ? errorBody.requestId : undefined,
    );
    if (response.status === 401) {
      csrfToken = undefined;
      window.dispatchEvent(new CustomEvent('auth-expired', { detail: error.message }));
    }
    if (
      response.status === 403 &&
      ((path.startsWith('/trials/') &&
        (method === undefined || method === 'GET' || path.endsWith('/query'))) ||
        path.startsWith('/analytics/') ||
        path.startsWith('/teaching-records/') ||
        path.startsWith('/report-manifests/') ||
        path.startsWith('/teaching/') ||
        /^\/students\/(?:follow-up-reminders\/query|[^/]+\/(?:operations|follow-ups|responsible-coach|growth-records|trial-sources)(?:[/?]|$))/u.test(
          path,
        ))
    ) {
      window.dispatchEvent(new CustomEvent('private-access-revoked'));
    }
    throw error;
  }
  if (isSessionUser(body)) {
    csrfToken = body.csrfToken;
  }
  return body as T;
}

function safeVersionDetails(
  value: unknown,
): Readonly<{ currentVersion?: string; currentPersonVersion?: string }> {
  if (typeof value !== 'object' || value === null) return {};
  const result: { currentVersion?: string; currentPersonVersion?: string } = {};
  for (const key of ['currentVersion', 'currentPersonVersion'] as const) {
    if (key in value) {
      const candidate: unknown = Reflect.get(value, key);
      if (typeof candidate === 'string' && /^[1-9]\d*$/u.test(candidate)) result[key] = candidate;
    }
  }
  return result;
}

function isApiErrorBody(value: unknown): value is ApiErrorBody {
  return typeof value === 'object' && value !== null;
}

function isSessionUser(value: unknown): value is SessionUser {
  return (
    typeof value === 'object' &&
    value !== null &&
    'csrfToken' in value &&
    typeof value.csrfToken === 'string'
  );
}

export const api = {
  assessmentStandard: (signal?: AbortSignal) =>
    request<AssessmentStandard>('/teaching/assessment-standards/current', signal ? { signal } : {}),
  saveTrialAssessment: (id: string, input: TrialAssessment, key: string) =>
    request<TeachingWriteResult>(`/trials/appointments/${encodeURIComponent(id)}/assessments`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  saveTrialFeedback: (id: string, input: TrialFeedback, key: string) =>
    request<TeachingWriteResult>(
      `/trials/appointments/${encodeURIComponent(id)}/teaching-feedback`,
      { method: 'POST', body: JSON.stringify(input), headers: { 'idempotency-key': key } },
    ),
  teachingRecord: (id: string, signal?: AbortSignal) =>
    request<TeachingDetail>(
      `/teaching-records/${encodeURIComponent(id)}`,
      signal ? { signal } : {},
    ),
  teachingHistory: (id: string, page: number, signal?: AbortSignal) =>
    request<TeachingHistory>(
      `/teaching-records/${encodeURIComponent(id)}/revisions?page=${String(page)}&pageSize=20`,
      signal ? { signal } : {},
    ),
  correctTeaching: (id: string, input: TeachingCorrection, key: string) =>
    request<TeachingWriteResult>(`/teaching-records/${encodeURIComponent(id)}/corrections`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  generateReport: (
    id: string,
    teachingVersion: string,
    reportKind: 'TRIAL' | 'FORMAL',
    key: string,
  ) =>
    request<ReportManifest>(`/teaching-records/${encodeURIComponent(id)}/report-manifests`, {
      method: 'POST',
      body: JSON.stringify({
        teachingVersion,
        reportKind,
        templateVersion: 'teaching-report-20261016.v2',
      }),
      headers: { 'idempotency-key': key },
    }),
  reportManifest: (id: string, signal?: AbortSignal) =>
    request<ReportManifest>(
      `/report-manifests/${encodeURIComponent(id)}`,
      signal ? { signal } : {},
    ),
  authorizeReportDownload: (id: string, signal?: AbortSignal) =>
    request<ReportDownloadAuthorization>(
      `/report-manifests/${encodeURIComponent(id)}/download-authorization`,
      { method: 'POST', body: '{}', ...(signal ? { signal } : {}) },
    ),
  trialFormalLink: (id: string, signal?: AbortSignal) =>
    request<FormalLink>(
      `/trials/people/${encodeURIComponent(id)}/formal-link`,
      signal ? { signal } : {},
    ),
  enrollTrialPerson: (id: string, input: TrialEnrollment, key: string) =>
    request<TrialEnrollmentResult>(`/trials/people/${encodeURIComponent(id)}/purchases`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  correctTrialFormalLink: (id: string, input: TrialLinkCorrection, key: string) =>
    request<FormalLink>(`/trials/people/${encodeURIComponent(id)}/link-corrections`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  trialGrowthRecords: (id: string, input: GrowthQuery, signal?: AbortSignal) =>
    request<GrowthPage>(`/trials/people/${encodeURIComponent(id)}/growth-records/query`, {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),
  studentGrowthRecords: (id: string, input: GrowthQuery, signal?: AbortSignal) =>
    request<GrowthPage>(`/students/${encodeURIComponent(id)}/growth-records/query`, {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),
  studentTrialSources: (
    id: string,
    page: { readonly page: number; readonly pageSize: number },
    signal?: AbortSignal,
  ) =>
    request<TrialSourcesPage>(`/students/${encodeURIComponent(id)}/trial-sources/query`, {
      method: 'POST',
      body: JSON.stringify(page),
      ...(signal ? { signal } : {}),
    }),
  trialPeople: (input: TrialPeopleQuery, signal?: AbortSignal) =>
    request<TrialPeoplePage>('/trials/people/query', {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),
  trialPerson: (id: string, signal?: AbortSignal) =>
    request<TrialPerson>(`/trials/people/${encodeURIComponent(id)}`, signal ? { signal } : {}),
  trialOptions: (input: TrialOptionsQuery, signal?: AbortSignal) =>
    request<TrialOptionsPage>('/trials/options/query', {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),
  trialAppointments: (input: TrialAppointmentsQuery, signal?: AbortSignal) =>
    request<TrialAppointmentsPage>('/trials/appointments/query', {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),
  trialAppointment: (id: string, signal?: AbortSignal) =>
    request<TrialAppointmentDetail>(
      `/trials/appointments/${encodeURIComponent(id)}`,
      signal ? { signal } : {},
    ),
  createTrial: (input: TrialCreate, key: string) =>
    request<Schemas['TrialCreateResponseDto']>('/trials/appointments', {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  updateTrial: (id: string, input: TrialUpdate, key: string) =>
    request<TrialAppointmentDetail>(`/trials/appointments/${encodeURIComponent(id)}/updates`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  teachTrial: (id: string, input: TrialTeaching, key: string) =>
    request<Schemas['TrialTeachingResponseDto']>(
      `/trials/appointments/${encodeURIComponent(id)}/teaching`,
      { method: 'POST', body: JSON.stringify(input), headers: { 'idempotency-key': key } },
    ),
  followUpTrial: (id: string, input: TrialFollowUp, key: string) =>
    request<Schemas['TrialFollowUpWriteResponseDto']>(
      `/trials/appointments/${encodeURIComponent(id)}/follow-ups`,
      { method: 'POST', body: JSON.stringify(input), headers: { 'idempotency-key': key } },
    ),
  handoverTrial: (id: string, input: TrialHandover, key: string) =>
    request<TrialAppointmentDetail>(`/trials/appointments/${encodeURIComponent(id)}/handovers`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  correctTrial: (id: string, input: TrialCorrection, key: string) =>
    request<TrialAppointmentDetail>(`/trials/appointments/${encodeURIComponent(id)}/corrections`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
    }),
  trialFollowUps: (id: string, page: number, signal?: AbortSignal) =>
    request<TrialFollowUpsPage>(
      `/trials/appointments/${encodeURIComponent(id)}/follow-ups?page=${String(page)}&pageSize=20`,
      signal ? { signal } : {},
    ),
  trialCorrections: (id: string, followUpId: string, page: number, signal?: AbortSignal) =>
    request<TrialCorrectionsPage>(
      `/trials/appointments/${encodeURIComponent(id)}/follow-ups/${encodeURIComponent(followUpId)}/corrections?page=${String(page)}&pageSize=20`,
      signal ? { signal } : {},
    ),
  trialHistory: (id: string, page: number, signal?: AbortSignal) =>
    request<TrialHistoryPageResponse>(
      `/trials/appointments/${encodeURIComponent(id)}/history?page=${String(page)}&pageSize=20`,
      signal ? { signal } : {},
    ),
  trialTasks: (input: TrialTasksQuery, signal?: AbortSignal) =>
    request<TrialTasksPage>('/trials/personal-follow-ups/query', {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),

  studentFollowUpReminders: (input: StudentRemindersInput, signal?: AbortSignal) =>
    request<StudentReminders>('/students/follow-up-reminders/query', {
      method: 'POST',
      body: JSON.stringify(input),
      ...(signal ? { signal } : {}),
    }),
  studentOperations: (studentId: string, signal?: AbortSignal) =>
    request<StudentOperations>(
      `/students/${encodeURIComponent(studentId)}/operations`,
      signal ? { signal } : {},
    ),
  studentFollowUps: (studentId: string, page: URLSearchParams, signal?: AbortSignal) =>
    request<StudentFollowUps>(
      `/students/${encodeURIComponent(studentId)}/follow-ups?${page.toString()}`,
      signal ? { signal } : {},
    ),
  studentFollowUpCorrections: (
    studentId: string,
    followUpId: string,
    page: URLSearchParams,
    signal?: AbortSignal,
  ) =>
    request<StudentFollowUpCorrections>(
      `/students/${encodeURIComponent(studentId)}/follow-ups/${encodeURIComponent(followUpId)}/corrections?${page.toString()}`,
      signal ? { signal } : {},
    ),
  appendStudentFollowUp: (
    studentId: string,
    input: CreateStudentFollowUpInput,
    idempotencyKey: string,
  ) =>
    request<StudentFollowUpWriteResult>(`/students/${encodeURIComponent(studentId)}/follow-ups`, {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'idempotency-key': idempotencyKey },
    }),
  correctStudentFollowUp: (
    studentId: string,
    followUpId: string,
    input: CorrectStudentFollowUpInput,
    idempotencyKey: string,
  ) =>
    request<StudentFollowUpCorrectionResult>(
      `/students/${encodeURIComponent(studentId)}/follow-ups/${encodeURIComponent(followUpId)}/corrections`,
      {
        method: 'POST',
        body: JSON.stringify(input),
        headers: { 'idempotency-key': idempotencyKey },
      },
    ),
  setStudentResponsibleCoach: (
    studentId: string,
    input: SetStudentResponsibleCoachInput,
    idempotencyKey: string,
  ) =>
    request<StudentResponsibleCoachResult>(
      `/students/${encodeURIComponent(studentId)}/responsible-coach`,
      {
        method: 'PUT',
        body: JSON.stringify(input),
        headers: { 'idempotency-key': idempotencyKey },
      },
    ),
  analyticsTrialConversion: (input: TrialConversionAnalyticsInput, signal?: AbortSignal) =>
    request<TrialConversionAnalytics>('/analytics/trial-conversion/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsTrialConversionDetails: (input: TrialConversionDetailsInput, signal?: AbortSignal) =>
    request<TrialConversionDetails>('/analytics/trial-conversion/details/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsVenue: (input: VenueAnalyticsInput, signal?: AbortSignal) =>
    request<VenueAnalytics>('/analytics/venue/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsVenueDetails: (input: VenueDetailsInput, signal?: AbortSignal) =>
    request<VenueDetails>('/analytics/venue/details/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsFrontDesk: (input: FrontDeskAnalyticsInput, signal?: AbortSignal) =>
    request<FrontDeskAnalytics>('/analytics/front-desk/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsFrontDeskDetails: (input: FrontDeskDetailsInput, signal?: AbortSignal) =>
    request<FrontDeskDetails>('/analytics/front-desk/details/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsCoaches: (input: CoachesAnalyticsInput, signal?: AbortSignal) =>
    request<CoachesAnalytics>('/analytics/coaches/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsCoachesDetails: (input: CoachesDetailsInput, signal?: AbortSignal) =>
    request<CoachesDetails>('/analytics/coaches/details/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsStudents: (input: StudentsAnalyticsInput, signal?: AbortSignal) =>
    request<StudentsAnalytics>('/analytics/students/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsStudentsDetails: (input: StudentsDetailsInput, signal?: AbortSignal) =>
    request<StudentsDetails>('/analytics/students/details/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  analyticsDirectory: (input: AnalyticsDirectoryInput, signal?: AbortSignal) =>
    request<AnalyticsDirectory>('/analytics/filter-options/query', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  purchaseActivity: (query: URLSearchParams, signal?: AbortSignal) =>
    request<PurchaseActivity>(`/purchases/activity?${query.toString()}`, signal ? { signal } : {}),
  analyticsFilterOptions: (query: URLSearchParams) =>
    request<AnalyticsFilterOptions>(`/analytics/consumption/filter-options?${query.toString()}`),
  analyticsOverview: (query: URLSearchParams) =>
    request<ConsumptionAnalyticsOverview>(`/analytics/consumption/overview?${query.toString()}`),
  analyticsStudentRankings: (query: URLSearchParams) =>
    request<StudentRanking>(`/analytics/consumption/student-rankings?${query.toString()}`),
  analyticsTeacherRankings: (query: URLSearchParams) =>
    request<TeacherRanking>(`/analytics/consumption/teacher-rankings?${query.toString()}`),
  audits: (query: URLSearchParams) => request<AuditList>(`/audits?${query.toString()}`),
  changePassword: (newPassword: string) =>
    request<Schemas['SuccessResponseDto']>('/auth/password', {
      body: JSON.stringify({ newPassword }),
      method: 'PUT',
    }),
  createEmployee: (input: Schemas['CreateEmployeeRequestDto']) =>
    request<Employee>('/employees', {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  createStudent: (input: Schemas['CreateStudentRequestDto']) =>
    request<Student>('/students', {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  createPackageTemplate: (input: Schemas['CreatePackageTemplateRequestDto']) =>
    request<PackageTemplate>('/package-templates', {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  createPurchase: (studentId: string, input: Schemas['CreatePurchaseRequestDto']) =>
    request<Purchase>(`/students/${encodeURIComponent(studentId)}/purchases`, {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  createFormula: (input: Schemas['CreateFormulaRequestDto']) =>
    request<CommissionFormula>('/commission-formulas', {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  createConsumptionBatch: (input: ConsumptionCreateInput, key: string) =>
    request<ConsumptionBatch>('/consumption-batches', {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': key },
      method: 'POST',
    }),
  createUpload: (input: Schemas['CreateUploadRequestDto']) =>
    request<Schemas['CreateUploadResponseDto']>('/uploads', {
      body: JSON.stringify(input),
      method: 'POST',
    }),
  createExportTask: (input: Schemas['CreateExportTaskRequestDto']) =>
    request<ExportTask>('/export-tasks', {
      body: JSON.stringify(input),
      headers: { 'x-idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  createDailyTaskTemplate: (
    input: Schemas['CreateDailyTaskTemplateRequestDto'],
    idempotencyKey: string,
  ) =>
    request<DailyTaskTemplate>('/daily-task-templates', {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': idempotencyKey },
      method: 'POST',
    }),
  employee: (id: string) => request<Employee>(`/employees/${encodeURIComponent(id)}`),
  correctConsumptionTheme: (id: string, input: ConsumptionThemeCorrection, key: string) =>
    request<ConsumptionBatch>(
      `/consumption-batches/${encodeURIComponent(id)}/teaching-theme/corrections`,
      {
        method: 'POST',
        body: JSON.stringify(input),
        headers: { 'idempotency-key': key },
      },
    ),
  consumptionBatch: (id: string, signal?: AbortSignal) =>
    request<ConsumptionBatch>(
      `/consumption-batches/${encodeURIComponent(id)}`,
      signal ? { signal } : {},
    ),
  consumptionBatchAudits: (id: string, query: URLSearchParams) =>
    request<ConsumptionBatchAuditList>(
      `/consumption-batches/${encodeURIComponent(id)}/audits?${query.toString()}`,
    ),
  consumption: (id: string) => request<Consumption>(`/consumptions/${encodeURIComponent(id)}`),
  consumptionAudits: (id: string) =>
    request<Schemas['ConsumptionAuditListResponseDto']>(
      `/consumptions/${encodeURIComponent(id)}/audits`,
    ),
  consumptionOptions: (packageTemplateId: string) =>
    request<ConsumptionOptions>(
      `/consumption-options?packageTemplateIds=${encodeURIComponent(packageTemplateId)}`,
    ),
  consumptions: (query: URLSearchParams) =>
    request<ConsumptionList>(`/consumptions?${query.toString()}`),
  commissionSummary: (query: URLSearchParams) =>
    request<CommissionSummary>(`/commissions/summary?${query.toString()}`),
  commissionDetails: (query: URLSearchParams) =>
    request<CommissionDetails>(`/commissions/details?${query.toString()}`),
  commissionPlan: (id: string) =>
    request<CommissionPlan>(`/commission-plans/${encodeURIComponent(id)}`),
  commissionPlanRevisions: (id: string) =>
    request<CommissionPlanRevisionList>(`/commission-plans/${encodeURIComponent(id)}/revisions`),
  commissionPlans: (query: URLSearchParams) =>
    request<CommissionPlanList>(`/commission-plans?${query.toString()}`),
  salesCommissionMonths: (query: URLSearchParams) =>
    request<SalesCommissionMonths>(`/sales-commissions/months?${query.toString()}`),
  mySalesCommissionMonths: (query: URLSearchParams) =>
    request<MySalesCommissionMonths>(`/sales-commissions/me/months?${query.toString()}`),
  salesCommissionPurchases: (employeeId: string, month: string, query: URLSearchParams) =>
    request<SalesCommissionPurchases>(
      `/sales-commissions/employees/${encodeURIComponent(employeeId)}/months/${encodeURIComponent(month)}/purchases?${query.toString()}`,
    ),
  mySalesCommissionPurchases: (month: string, query: URLSearchParams) =>
    request<SalesCommissionPurchases>(
      `/sales-commissions/me/months/${encodeURIComponent(month)}/purchases?${query.toString()}`,
    ),
  salesCommissionPlans: (query: URLSearchParams) =>
    request<SalesCommissionPlanList>(`/sales-commission-plans?${query.toString()}`),
  salesCommissionPlan: (employeeId: string) =>
    request<SalesCommissionPlan>(
      `/sales-commission-plans/employees/${encodeURIComponent(employeeId)}`,
    ),
  salesCommissionPlanRevisions: (employeeId: string, query: URLSearchParams) =>
    request<SalesCommissionPlanRevisionList>(
      `/sales-commission-plans/employees/${encodeURIComponent(employeeId)}/revisions?${query.toString()}`,
    ),
  employeeAudits: (id: string) =>
    request<Schemas['EmployeeAuditListResponseDto']>(`/employees/${encodeURIComponent(id)}/audits`),
  employees: (query: URLSearchParams, signal?: AbortSignal) =>
    request<EmployeeList>(`/employees?${query.toString()}`, signal ? { signal } : {}),
  exportTasks: (query: URLSearchParams) =>
    request<ExportTaskList>(`/export-tasks?${query.toString()}`),
  exportTaskDownload: (id: string) =>
    request<Schemas['ExportDownloadResponseDto']>(
      `/export-tasks/${encodeURIComponent(id)}/download`,
    ),
  completeUpload: (id: string) =>
    request<FileStatus>(`/uploads/${encodeURIComponent(id)}/complete`, { method: 'POST' }),
  fileStatus: (id: string) => request<FileStatus>(`/uploads/${encodeURIComponent(id)}`),
  fileView: (id: string) =>
    request<Schemas['FileViewResponseDto']>(`/files/${encodeURIComponent(id)}/view`),
  dailyTaskTemplates: (query: URLSearchParams) =>
    request<DailyTaskTemplateList>(`/daily-task-templates?${query.toString()}`),
  dailyTaskTemplate: (id: string) =>
    request<DailyTaskTemplate>(`/daily-task-templates/${encodeURIComponent(id)}`),
  dailyTaskTemplateRevisions: (id: string, query: URLSearchParams) =>
    request<DailyTaskTemplateRevisionList>(
      `/daily-task-templates/${encodeURIComponent(id)}/revisions?${query.toString()}`,
    ),
  dailyTasksToday: () => request<DailyTaskToday>('/daily-tasks/today'),
  dailyTaskReviewTodaySummary: () =>
    request<Schemas['DailyTaskTodayReviewSummaryDto']>('/daily-task-reviews/today-summary'),
  dailyTaskReviews: (query: URLSearchParams) =>
    request<DailyTaskReviewList>(`/daily-task-reviews?${query.toString()}`),
  dailyTaskInstance: (id: string) =>
    request<DailyTaskInstance>(`/daily-task-instances/${encodeURIComponent(id)}`),
  dailyTaskEvidence: (query: URLSearchParams) =>
    request<DailyTaskEvidenceList>(`/daily-task-evidence?${query.toString()}`),
  login: (loginName: string, password: string) =>
    request<SessionUser>('/auth/login', {
      body: JSON.stringify({ loginName, password }),
      method: 'POST',
    }),
  logout: async () => {
    const result = await request<Schemas['SuccessResponseDto']>('/auth/logout', { method: 'POST' });
    csrfToken = undefined;
    return result;
  },
  me: () => request<SessionUser>('/auth/me'),
  notifications: () => request<NotificationList>('/notifications'),
  notificationUnreadCount: () =>
    request<Schemas['NotificationUnreadCountResponseDto']>('/notifications/unread-count'),
  markNotificationRead: (id: string) =>
    request<Schemas['MarkNotificationReadResponseDto']>(
      `/notifications/${encodeURIComponent(id)}/read`,
      { method: 'POST' },
    ),
  packageTemplate: (id: string) =>
    request<PackageTemplate>(`/package-templates/${encodeURIComponent(id)}`),
  purchase: (id: string) => request<Purchase>(`/purchases/${encodeURIComponent(id)}`),
  updatePurchaseSalesAttribution: (
    purchase: Purchase,
    input: Omit<Schemas['UpdatePurchaseSalesAttributionRequestDto'], 'version'>,
  ) =>
    request<Purchase>(`/purchases/${encodeURIComponent(purchase.id)}/sales-attribution`, {
      body: JSON.stringify({
        salesEmployeeId: input.salesEmployeeId,
        salesAttributedAt: input.salesAttributedAt,
        reason: input.reason,
        version: purchase.version,
      }),
      method: 'PATCH',
    }),
  purchaseAudits: (id: string) =>
    request<Schemas['PurchaseAuditListResponseDto']>(`/purchases/${encodeURIComponent(id)}/audits`),
  packageTemplates: (query: URLSearchParams) =>
    request<Schemas['PackageTemplateListResponseDto']>(`/package-templates?${query.toString()}`),
  commissionFormula: (id: string) =>
    request<CommissionFormula>(`/commission-formulas/${encodeURIComponent(id)}`),
  commissionFormulas: (query: URLSearchParams) =>
    request<Schemas['FormulaListResponseDto']>(`/commission-formulas?${query.toString()}`),
  previewFormula: (input: Schemas['FormulaPreviewRequestDto']) =>
    request<Schemas['FormulaPreviewResponseDto']>('/commission-formulas/preview', {
      body: JSON.stringify(input),
      method: 'POST',
    }),
  previewConsumptionBatch: (
    input: Schemas['PreviewConsumptionBatchRequestDto'],
    signal?: AbortSignal,
  ) =>
    request<Schemas['ConsumptionBatchPreviewResponseDto']>('/consumption-batches/preview', {
      body: JSON.stringify(input),
      method: 'POST',
      ...(signal ? { signal } : {}),
    }),
  resetEmployeePassword: (id: string, newPassword: string) =>
    request<Schemas['SuccessResponseDto']>(`/employees/${encodeURIComponent(id)}/reset-password`, {
      body: JSON.stringify({ confirm: true, newPassword }),
      method: 'POST',
    }),
  retryUploadScan: (id: string) =>
    request<FileStatus>(`/uploads/${encodeURIComponent(id)}/retry-scan`, { method: 'POST' }),
  retryExportTask: (id: string) =>
    request<ExportTask>(`/export-tasks/${encodeURIComponent(id)}/retry`, {
      headers: { 'x-idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  submitDailyTask: (
    id: string,
    input: Schemas['CreateDailyTaskSubmissionRequestDto'],
    idempotencyKey: string,
  ) =>
    request<DailyTaskInstance>(`/daily-task-instances/${encodeURIComponent(id)}/submissions`, {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': idempotencyKey },
      method: 'POST',
    }),
  approveDailyTask: (submissionId: string, instanceVersion: string, idempotencyKey: string) =>
    request<DailyTaskInstance>(
      `/daily-task-submissions/${encodeURIComponent(submissionId)}/approve`,
      {
        body: JSON.stringify({ instanceVersion } satisfies Schemas['DailyTaskReviewRequestDto']),
        headers: { 'idempotency-key': idempotencyKey },
        method: 'POST',
      },
    ),
  rejectDailyTask: (
    submissionId: string,
    instanceVersion: string,
    reason: string,
    idempotencyKey: string,
  ) =>
    request<DailyTaskInstance>(
      `/daily-task-submissions/${encodeURIComponent(submissionId)}/reject`,
      {
        body: JSON.stringify({
          instanceVersion,
          reason,
        } satisfies Schemas['DailyTaskRejectRequestDto']),
        headers: { 'idempotency-key': idempotencyKey },
        method: 'POST',
      },
    ),
  withdrawDailyTaskApproval: (
    id: string,
    version: string,
    reason: string,
    idempotencyKey: string,
  ) =>
    request<DailyTaskInstance>(
      `/daily-task-instances/${encodeURIComponent(id)}/withdraw-approval`,
      {
        body: JSON.stringify({ reason, version } satisfies Schemas['DailyTaskReasonRequestDto']),
        headers: { 'idempotency-key': idempotencyKey },
        method: 'POST',
      },
    ),
  cancelDailyTask: (id: string, version: string, reason: string, idempotencyKey: string) =>
    request<DailyTaskInstance>(`/daily-task-instances/${encodeURIComponent(id)}/cancel`, {
      body: JSON.stringify({ reason, version } satisfies Schemas['DailyTaskReasonRequestDto']),
      headers: { 'idempotency-key': idempotencyKey },
      method: 'POST',
    }),
  reconciliationRuns: () => request<ReconciliationRunList>('/reconciliation-runs'),
  runReconciliation: () => request<ReconciliationRun>('/reconciliation-runs', { method: 'POST' }),
  replacePurchaseVoucher: (purchase: Purchase, voucherUploadId: string, reason: string) =>
    request<Purchase>(`/purchases/${encodeURIComponent(purchase.id)}/replace-voucher`, {
      body: JSON.stringify({ reason, version: purchase.version, voucherUploadId }),
      method: 'POST',
    }),
  replaceConsumptionVoucher: (batch: ConsumptionBatch, voucherUploadId: string, reason: string) =>
    request<ConsumptionBatch>(
      `/consumption-batches/${encodeURIComponent(batch.id)}/replace-voucher`,
      {
        body: JSON.stringify({ reason, version: batch.version, voucherUploadId }),
        method: 'POST',
      },
    ),
  student: (id: string, signal?: AbortSignal) =>
    request<Student>(`/students/${encodeURIComponent(id)}`, signal ? { signal } : {}),
  studentAudits: (id: string) =>
    request<Schemas['StudentAuditListResponseDto']>(`/students/${encodeURIComponent(id)}/audits`),
  studentConsumptions: (id: string, query: URLSearchParams) =>
    request<Schemas['StudentConsumptionListResponseDto']>(
      `/students/${encodeURIComponent(id)}/consumptions?${query.toString()}`,
    ),
  studentDuplicateCheck: (input: Schemas['DuplicateStudentRequestDto']) =>
    request<Schemas['DuplicateStudentResponseDto']>('/students/duplicate-check', {
      body: JSON.stringify(input),
      method: 'POST',
    }),
  studentPurchases: (id: string, query: URLSearchParams) =>
    request<Schemas['StudentPurchaseListResponseDto']>(
      `/students/${encodeURIComponent(id)}/purchases?${query.toString()}`,
    ),
  students: (query: URLSearchParams, signal?: AbortSignal) =>
    request<StudentList>(`/students?${query.toString()}`, signal ? { signal } : {}),
  setPurchaseStatus: (purchase: Purchase, reason: string | null) =>
    request<Purchase>(
      `/purchases/${encodeURIComponent(purchase.id)}/${purchase.status === 'ACTIVE' ? 'void' : 'restore'}`,
      { body: JSON.stringify({ reason, version: purchase.version }), method: 'POST' },
    ),
  saveSalesCommissionPlan: (
    employeeId: string,
    input: Schemas['SaveSalesCommissionPlanRequestDto'],
  ) =>
    request<SalesCommissionPlan>(
      `/sales-commission-plans/employees/${encodeURIComponent(employeeId)}`,
      {
        body: JSON.stringify(input),
        headers: { 'idempotency-key': crypto.randomUUID() },
        method: 'PUT',
      },
    ),
  cancelConsumption: (consumption: Consumption, reason: string) =>
    request<Consumption>(`/consumptions/${encodeURIComponent(consumption.id)}/cancel`, {
      body: JSON.stringify({ reason, version: consumption.version }),
      method: 'POST',
    }),
  terminateEmployee: (employee: Employee) =>
    request<Employee>(`/employees/${encodeURIComponent(employee.id)}/terminate`, {
      body: JSON.stringify({ confirm: true, version: employee.version }),
      method: 'POST',
    }),
  updateEmployee: (
    employee: Employee,
    input: { readonly employeeType?: Employee['employeeType']; readonly name?: string },
  ) =>
    request<Employee>(`/employees/${encodeURIComponent(employee.id)}`, {
      body: JSON.stringify({ ...input, version: employee.version }),
      method: 'PATCH',
    }),
  updateConsumptionBatch: (
    batch: ConsumptionBatch,
    input: Omit<Schemas['UpdateConsumptionBatchRequestDto'], 'version'>,
  ) =>
    request<ConsumptionBatch>(`/consumption-batches/${encodeURIComponent(batch.id)}`, {
      body: JSON.stringify({ ...input, version: batch.version }),
      method: 'PATCH',
    }),
  updateConsumption: (
    consumption: Consumption,
    input: Omit<Schemas['UpdateConsumptionRequestDto'], 'version'>,
  ) =>
    request<Consumption>(`/consumptions/${encodeURIComponent(consumption.id)}`, {
      body: JSON.stringify({ ...input, version: consumption.version }),
      method: 'PATCH',
    }),
  updateStudent: (student: Student, input: Omit<Schemas['UpdateStudentRequestDto'], 'version'>) =>
    request<Student>(`/students/${encodeURIComponent(student.id)}`, {
      body: JSON.stringify({ ...input, version: student.version }),
      method: 'PATCH',
    }),
  markStudentLost: (student: Student, reason: string | null) =>
    request<Student>(`/students/${encodeURIComponent(student.id)}/mark-lost`, {
      body: JSON.stringify({ reason, version: student.version }),
      method: 'POST',
    }),
  restoreStudentActive: (student: Student) =>
    request<Student>(`/students/${encodeURIComponent(student.id)}/restore-active`, {
      body: JSON.stringify({ version: student.version }),
      method: 'POST',
    }),
  updatePackageTemplate: (
    template: PackageTemplate,
    input: Omit<Schemas['UpdatePackageTemplateRequestDto'], 'version'>,
  ) =>
    request<PackageTemplate>(`/package-templates/${encodeURIComponent(template.id)}`, {
      body: JSON.stringify({ ...input, version: template.version }),
      method: 'PATCH',
    }),
  updatePurchase: (
    purchase: Purchase,
    input: Omit<Schemas['UpdatePurchaseRequestDto'], 'version'>,
  ) =>
    request<Purchase>(`/purchases/${encodeURIComponent(purchase.id)}`, {
      body: JSON.stringify({ ...input, version: purchase.version }),
      method: 'PATCH',
    }),
  setPackageTemplateStatus: (template: PackageTemplate) =>
    request<PackageTemplate>(
      `/package-templates/${encodeURIComponent(template.id)}/${template.status === 'ACTIVE' ? 'deactivate' : 'activate'}`,
      { body: JSON.stringify({ version: template.version }), method: 'POST' },
    ),
  setFormulaStatus: (formula: CommissionFormula) =>
    request<CommissionFormula>(
      `/commission-formulas/${encodeURIComponent(formula.id)}/${formula.status === 'ACTIVE' ? 'deactivate' : 'activate'}`,
      { body: JSON.stringify({ version: formula.version }), method: 'POST' },
    ),
  saveCommissionPlan: (plan: CommissionPlan, input: Schemas['SaveCommissionPlanRequestDto']) =>
    request<CommissionPlan>(`/commission-plans/${encodeURIComponent(plan.id)}`, {
      body: JSON.stringify(input),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'PUT',
    }),
  copyCommissionPlan: (plan: CommissionPlan, sourcePlanId: string, reason: string) =>
    request<CommissionPlan>(`/commission-plans/${encodeURIComponent(plan.id)}/copy`, {
      body: JSON.stringify({ reason, sourcePlanId, version: plan.version }),
      headers: { 'idempotency-key': crypto.randomUUID() },
      method: 'POST',
    }),
  updateDailyTaskTemplate: (
    template: DailyTaskTemplate,
    input: Omit<Schemas['UpdateDailyTaskTemplateRequestDto'], 'version'>,
    idempotencyKey: string,
  ) =>
    request<DailyTaskTemplate>(`/daily-task-templates/${encodeURIComponent(template.id)}`, {
      body: JSON.stringify({ ...input, version: template.version }),
      headers: { 'idempotency-key': idempotencyKey },
      method: 'PATCH',
    }),
  setDailyTaskTemplateStatus: (template: DailyTaskTemplate, idempotencyKey: string) =>
    request<DailyTaskTemplate>(
      `/daily-task-templates/${encodeURIComponent(template.id)}/${template.status === 'ACTIVE' ? 'deactivate' : 'activate'}`,
      {
        body: JSON.stringify({
          version: template.version,
        } satisfies Schemas['DailyTaskVersionRequestDto']),
        headers: { 'idempotency-key': idempotencyKey },
        method: 'POST',
      },
    ),
};
